import React, { useRef } from 'react';
import styled from 'styled-components';
import Navbar, { SCROLL_BEHAVIOR } from './Navbar';
import Footer from './Footer';
import { HomePage } from 'view/pages/Home';
import { ExposureLanding } from 'view/pages/ExposureLanding';
import { CTGCBanner } from '../common/CTGCBanner';

type Props = React.HTMLAttributes<HTMLDivElement>;

/** Same shell as the homepage splash, with /audit hero and CTA */
export const AuditSplashLayout: React.FunctionComponent<Props> = () =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Navbar 
                scrollBehavior={{ 
                    mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL 
                }} 
            />
            <Container id="container" ref={ref}>
                <NavSpacer />
                <HomePage auditLanding="audit" />
                <Footer isFullHeight={true} />
                <CTGCBanner />
            </Container>
        </>
    );
};

/** Duplicate of audit landing for /footprint */
export const FootprintSplashLayout: React.FunctionComponent<Props> = () =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Navbar 
                scrollBehavior={{ 
                    mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL 
                }} 
            />
            <Container id="container" ref={ref}>
                <NavSpacer />
                <HomePage auditLanding="footprint" />
                <Footer isFullHeight={true} />
                <CTGCBanner />
            </Container>
        </>
    );
};

/** Duplicate of audit landing for /emr */
export const EmrSplashLayout: React.FunctionComponent<Props> = () =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Navbar 
                scrollBehavior={{ 
                    mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL 
                }} 
            />
            <Container id="container" ref={ref}>
                <NavSpacer />
                <HomePage auditLanding="emr" />
                <Footer isFullHeight={true} />
                <CTGCBanner />
            </Container>
        </>
    );
};

/** Duplicate of audit landing for /estate */
export const EstateSplashLayout: React.FunctionComponent<Props> = () =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Navbar 
                scrollBehavior={{ 
                    mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL 
                }} 
            />
            <Container id="container" ref={ref}>
                <NavSpacer />
                <HomePage auditLanding="estate" />
                <Footer isFullHeight={true} />
                <CTGCBanner />
            </Container>
        </>
    );
};

/** Duplicate of audit landing for /estate-1 */
export const Estate1SplashLayout: React.FunctionComponent<Props> = () =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Navbar 
                scrollBehavior={{ 
                    mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL 
                }} 
            />
            <Container id="container" ref={ref}>
                <NavSpacer />
                <HomePage auditLanding="estate-1" />
                <Footer isFullHeight={true} />
                <CTGCBanner />
            </Container>
        </>
    );
};

/** Duplicate of audit landing for /exposure-report */
export const ExposureReportSplashLayout: React.FunctionComponent<Props> = () =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Navbar 
                scrollBehavior={{ 
                    mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL 
                }} 
            />
            <Container id="container" ref={ref}>
                <NavSpacer />
                <HomePage auditLanding="exposure-report" />
                <Footer isFullHeight={true} />
                <CTGCBanner />
            </Container>
        </>
    );
};

/** Strategy-call landing at /contact */
export const ExposureLandingSplashLayout: React.FunctionComponent<Props> = () =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Navbar 
                scrollBehavior={{ 
                    mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL 
                }} 
            />
            <Container id="container" ref={ref}>
                <NavSpacer />
                <ExposureLanding />
                <Footer isFullHeight={true} />
                <CTGCBanner />
            </Container>
        </>
    );
};

/** Duplicate of audit landing for /fixme */
export const FixmeSplashLayout: React.FunctionComponent<Props> = () =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Navbar 
                scrollBehavior={{ 
                    mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL 
                }} 
            />
            <Container id="container" ref={ref}>
                <NavSpacer />
                <HomePage auditLanding="fixme" />
                <Footer isFullHeight={true} />
                <CTGCBanner />
            </Container>
        </>
    );
};

/** Duplicate of audit landing with alternate hero copy (/audit-a) */
export const AuditASplashLayout: React.FunctionComponent<Props> = () =>
{
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Navbar 
                scrollBehavior={{ 
                    mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL 
                }} 
            />
            <Container id="container" ref={ref}>
                <NavSpacer />
                <HomePage auditLanding="audit-a" />
                <Footer isFullHeight={true} />
                <CTGCBanner />
            </Container>
        </>
    );
};

const Container = styled.div`
    position: relative;
    width : 100%;
    overflow-x: hidden;
`;

const NavSpacer = styled.div`
    position: sticky;
    top: 0;
    height: 77px;
    pointer-events: none;
    background: transparent;
    z-index: 0;
`;
